module.exports = __webpack_public_path__ + "static/media/award-purple.54dc7304.svg";